// extracted by mini-css-extract-plugin
export default {"container":"HPCjcrTMNx2BbZXpu9h5","addNoteButton":"ReR2cyOk6VEI4FnvORjM","notesList":"Mtx6LwIB8f6dJ7xXTTF3"};